export const projects = [
  {
    title: 'Portfolio Web',
    description:
      'This website. It has shown some of my projects and something that I want to share. It have included interesting features such as animated model/icons, dark mode, language mode, and tsparticles.',
    image: require('../assets/proj/portfolio.PNG'),
    tags: ['React', 'Redux', 'ThreeJs', 'API','Hooks'],
    source: 'https://github.com/Chaoran-Zhao/newPortfolio',
    visit: 'https://chaoranzcr.com/',
    color: '#457b9d',
    id: 0,
  },
  {
    title: 'Travel Bill Calculator',
    description:
      "A full stack project that users can input their travel expenses, split the cost among group members, and calculate each person's share of the bill. The project utilizes Python Flask, Jinja, SQLite, Bootstrap.",
    image: require('../assets/proj/proj6.PNG'),
    tags: ['Flask', 'Python', 'Jinja', 'Sqlite', 'Bootstrap', 'Postgresql'],
    source: 'https://github.com/Chaoran-Zhao/BillSplit_FullStack',
    visit: 'https://billsplitweb.onrender.com/',
    color: '#d0bb57',
    id: 3,
  },
  {
    title: 'Game Web',
    description:
      'A website that includes small games such as Tic Tac Toe, Slido, and etc. It has shown a strong usage of react hooks.',
    image: require('../assets/proj/Game.PNG'),
    tags: ['React', 'Hooks'],
    source: 'https://github.com/Chaoran-Zhao/small-game-web',
    visit: 'https://incandescent-rolypoly-4f1c6d.netlify.app',
    color: '#457b9d',
    id: 2,
  },
  {
    title: 'TodoApp Web',
    description:
      'A full stack project that is implemented via (MongoDB, Express, React, Node). Intresting features include jwttoken, bcrypt, Formspree, ics-file and etc.',
    image: require('../assets/proj/proj4.PNG'),
    tags: ['Mongodb', 'Express', 'React', 'Node', 'MUI'],
    source: 'https://github.com/Chaoran-Zhao/todoApp',
    visit: 'https://prismatic-gelato-bf9f2c.netlify.app',
    color: '#d0bb57',
    id: 3,
  },
  {
    title: 'Weather Broadcast ',
    description:
      'A website that implements a interactive mario-style via html canvas and when you reach the destination, it utilises geolocation & OpenWeather api to give users the weather info of current location.',
    image: require('../assets/proj/after.PNG'),
    tags: ['JavaScript', 'Canvas', 'API'],
    source: 'https://github.com/Chaoran-Zhao/mario-style-weather-report',
    visit: 'https://voluble-tarsier-311ea5.netlify.app',
    color: '#457b9d',
    id: 1,
  },

  {
    title: 'MyReact',
    description:
      'This project has replicated a very simplified version of React focused on diffing on the virtual DOM and rendering on real DOM.',
    image: require('../assets/proj/proj5.PNG'),
    tags: ['JavaScript'],
    source: 'https://github.com/Chaoran-Zhao/myReact',
    visit: 'https://gleeful-croissant-4d3241.netlify.app/',
    color: '#58201e',
    id: 4,
  },
  {
    title: 'Bill Split App',
    description:
      'This is a Bill Split App developed using React Native. There has no backend support and only mock-up data is used. ',
    image: require('../assets/proj/proj_n.png'),
    tags: ['React Native'],
    source: 'https://github.com/Chaoran-Zhao/ReactNativeAPP',
    visit: '',
    color: '#457b9d',
    id: 5,
  },
];
